// eslint-disable-next-line @typescript-eslint/no-inferrable-types
const MODE: number = 4


export let URL = "http://192.168.1.46/"
export let BASE_URL = `http://192.168.1.46/labtest/elite-api-autoquote/v1/`
export let BEARER_TOKEN: string = process.env.REACT_APP_TOKEN!
export let BASE_URL_IMG = "https://img.piranhaoffroad.es/"



if (MODE === 2) {
    URL = "http://192.168.1.46/"
    BASE_URL = `http://192.168.1.46/labtest/elite-api-autoquote/v1/`
    BEARER_TOKEN = process.env.REACT_APP_TOKEN!
    BASE_URL_IMG = "http://img.piranhaoffroad.es/"


} else if (MODE === 1) {
    URL = "https://api.piranhaoffroad.es/"
    BASE_URL = "https://api.piranhaoffroad.es/"
    BASE_URL_IMG = "https://img.piranhaoffroad.es/"
    BEARER_TOKEN = process.env.REACT_APP_TOKEN!
} else if (MODE === 3) {
    URL = "http://api.piranhatc.com.au/elitesports17/"
    BASE_URL = "http://api.piranhatc.com.au/elitesports17/"
    BASE_URL_IMG = "https://img.piranhatc.com.au/elitesports17/"
    BEARER_TOKEN = process.env.REACT_APP_TOKEN!

} else if (MODE === 4) {
    URL = "https://quotes.piranhatc.com.au/api/"
    BASE_URL = "https://quotes.piranhatc.com.au/api/"
    BASE_URL_IMG = "https://img.piranhatc.com.au/"
    BEARER_TOKEN = process.env.REACT_APP_TOKEN!


}

export const FORM = "form"
export const QUOTES = "quotes"
export const LOGIN = "login"